import React from "react";

const MAP = {
  Borrador: "bg-slate-100 text-slate-700 border-slate-300",
  Enviada: "bg-blue-50 text-blue-800 border-blue-200",
  "En revisión": "bg-amber-50 text-amber-800 border-amber-200",
  "Información adicional requerida": "bg-orange-50 text-orange-800 border-orange-200",
  "Reevaluación solicitada": "bg-purple-50 text-purple-800 border-purple-200",
  Procesada: "bg-emerald-50 text-emerald-800 border-emerald-200",
};

export default function StatusBadge({ status, testId }) {
  const cls = MAP[status] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span data-testid={testId} className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold border ${cls}`}>
      {status}
    </span>
  );
}
